import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IListaAnhos } from 'src/app/interfaces/ponderaciones';
import { IListaPeriodos } from 'src/app/interfaces/utils';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  @Output() getServiceErrorModalData: EventEmitter<any> = new EventEmitter()

  constructor(
    private http: HttpClient
  ) { }
  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getRandomImages(): Observable<any> {
    const url = 'https://picsum.photos/200'
    return this.http.get<any>(url)
  }

  obtenerListaAnhos():Observable<IListaAnhos> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-anyos`
    return this.http.get<IListaAnhos>(url, { headers: this.getHeaders() })
  }
  
  obtenerListaPeriodos(anyo: number):Observable<IListaPeriodos> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-periodos?anyo=${anyo}`
    return this.http.get<IListaPeriodos>(url, { headers: this.getHeaders() })
  }

  asyncModalServiceError(data: any): Observable<boolean> {
    if ( data ) {
      this.getServiceErrorModalData.emit( data )
      return of(true)
    } else {
      this.getServiceErrorModalData.emit('off')
      return of(false)
    }
  }
}
